// A6 關於 / App 版本（spec 20 §8.2）。
// 顯示目前 build 版本；「檢查更新」= 重新整理取最新建置（web 無商店；11 §3.3
// build-time 版本）。真正的強制升級由全域 426 覆蓋頁處理（ForceUpgradeOverlay），
// 任一 REST 回 426 UPGRADE_REQUIRED 即觸發，本卡片僅提供手動檢查與版本資訊。
import { useTranslation } from 'react-i18next';
import { config } from '../../config';

export default function AboutCard() {
  const { t } = useTranslation();
  return (
    <div className="card">
      <h2 style={{ marginTop: 0, fontSize: 'var(--font-size-xl)' }}>{t('account.about')}</h2>
      <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 'var(--spacing-4) var(--spacing-8)' }}>
        <dt className="text-secondary">{t('account.application')}</dt>
        <dd style={{ margin: 0 }}>LS Cloud Web</dd>
        <dt className="text-secondary">{t('account.version')}</dt>
        <dd style={{ margin: 0 }}>{config.appVersion}</dd>
        <dt className="text-secondary">{t('account.environment')}</dt>
        <dd style={{ margin: 0 }}>{config.envName}</dd>
      </dl>
      <div style={{ marginTop: 'var(--spacing-5)' }}>
        <button className="btn-ghost" onClick={() => window.location.reload()}>
          {t('account.checkForUpdates')}
        </button>
        <p className="text-secondary" style={{ margin: 'var(--spacing-2) 0 0', fontSize: 'var(--font-size-sm)' }}>
          {t('account.refreshForLatest')}
        </p>
      </div>
    </div>
  );
}
